// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".process-status-img {\n  height: 180px;\n  position: absolute;\n  z-index: 999;\n  top: 1px;\n  right: 1px;\n}\n", ""]);
// Exports
module.exports = exports;
